import React, { Component } from 'react';
import { translate, setLanguage } from 'react-multi-lang';
import { browserHistory } from 'react-router';
import { getMenudata } from '../../actions/accountAction';
import store from "../../store";

class LanguageSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      basePath: window.location.protocol + '//' + window.location.host + '/',
      currentLanguage: this.getCurrentLanguage()
    }
    this.unlisten = null;
  }

  /**
   * Get current language from URL or localStorage, default to 'en'
   */
  getCurrentLanguage = () => {
    const pathname = window.location.pathname;
    const pathParts = pathname.split('/').filter(part => part);
    const validLanguages = ['hi', 'pa'];
    
    // Check URL first - if URL has language prefix, use it
    if (pathParts.length > 0 && validLanguages.includes(pathParts[0])) {
      return pathParts[0];
    }
    
    // If URL doesn't have language prefix, check localStorage
    const storedLang = localStorage.getItem('language');
    if (storedLang) {
      // If stored language is valid, use it
      if (validLanguages.includes(storedLang)) {
        return storedLang;
      }
      // If stored language is 'en', use it
      if (storedLang === 'en') {
        return 'en';
      }
    }
    
    // Default to English if nothing is set
    return 'en';
  }

  componentDidMount() {
    // Update language state on mount
    const currentLang = this.getCurrentLanguage();
    this.setState({ currentLanguage: currentLang });
    
    // Listen to browserHistory changes
    this.unlisten = browserHistory.listen((location) => {
      // Use a timeout to ensure window.location.pathname is updated
      setTimeout(() => {
        const newLang = this.getCurrentLanguage();
        this.setState({ currentLanguage: newLang });
      }, 0);
    });
  }

  componentWillUnmount() {
    // Clean up listener
    if (this.unlisten) {
      this.unlisten();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Update language when route changes
    const currentLang = this.getCurrentLanguage();
    if (currentLang !== this.state.currentLanguage) {
      this.setState({ currentLanguage: currentLang });
    }
  }

  /**
   * Get the current path without language prefix
   */
  getPathWithoutLanguage = () => {
    const pathname = window.location.pathname;
    const pathParts = pathname.split('/').filter(part => part);
    const validLanguages = ['hi', 'pa'];
    
    if (pathParts.length > 0 && validLanguages.includes(pathParts[0])) {
      return '/' + pathParts.slice(1).join('/');
    }
    return pathname || '/';
  }

  /**
   * Build URL with language prefix
   */
  buildUrlWithLanguage = (path, lang) => {
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    
    // For English, no prefix (just /)
    if (lang === 'en' || !lang) {
      return cleanPath ? `/${cleanPath}` : '/';
    }
    
    // For other languages, add prefix
    return cleanPath ? `/${lang}/${cleanPath}` : `/${lang}`;
  }

  changeLanguage = (event) => {
    localStorage.setItem('language', event);
    document.documentElement.lang = event;
    store.dispatch(getMenudata())
    setLanguage(event)
    
    // Update state immediately
    this.setState({ currentLanguage: event });
    
    // Get current path without language prefix
    const currentPath = this.getPathWithoutLanguage();
    
    // Build new URL with language prefix
    const newPath = this.buildUrlWithLanguage(currentPath, event);
    
    // Navigate to new URL
    browserHistory.push(newPath);
  }

  getEnglishStyle = () => {
    return {};
  }

  getPunjabiStyle = () => {
    return {};
  }

  getHindiStyle = () => {
    return {};
  }

  render() {
    return (
      // <li className="list-inline-item">
      //   <span onClick={() => this.changeLanguage('en')} style={{ "color": this.getEnglishStyle(), "cursor": "pointer" }}>English&nbsp;</span>/&nbsp;
      //   <span onClick={() => this.changeLanguage('pu')} style={{ "cursor": "pointer", "color": this.getPunjabiStyle() }}>ਪੰਜਾਬੀ&nbsp;</span>/&nbsp;
      //   <span onClick={() => this.changeLanguage('hi')} style={{ "cursor": "pointer", "color": this.getHindiStyle() }}>हिन्दी</span>
      // </li>
      <li className="list-inline-item" role="listitem">
        <button
          // onClick={() => this.changeLanguage('en')}
          onClick={() => {
            if (window.confirm("This will lead you to English language. Are you sure to switch to this language?")) {
              this.changeLanguage('en');
            }
          }}
          style={{ ...this.getEnglishStyle(), cursor: "pointer", background: "none", border: "none", padding: 0 }}
          lang="en"
          aria-label="Change language to English"
        >
          English
        </button>
        <span aria-hidden="true">&nbsp; / &nbsp;</span>

        <button
          // onClick={() => this.changeLanguage('pu')}
          onClick={() => {
            if (window.confirm("This will lead you to ਪੰਜਾਬੀ language. Are you sure to switch to this language?")) {
              this.changeLanguage('pa');
            }
          }}
          style={{ ...this.getPunjabiStyle(), cursor: "pointer", background: "none", border: "none", padding: 0 }}
          lang="pa"
          aria-label="Change language to Punjabi"
        >
          ਪੰਜਾਬੀ
        </button>
        <span aria-hidden="true">&nbsp; / &nbsp;</span>

        <button
          // onClick={() => this.changeLanguage('hi')}
          onClick={() => {
            if (window.confirm("This will lead you to हिन्दी language. Are you sure to switch to this language?")) {
              this.changeLanguage('hi');
            }
          }}
          style={{ ...this.getHindiStyle(), cursor: "pointer", background: "none", border: "none", padding: 0 }}
          lang="hi"
          aria-label="Change language to Hindi"
        >
          हिंदी
        </button>
      </li>

    )
  }
}

export default translate(LanguageSelector)

